import { LinearProgress, Stack, Typography } from '@mui/material';
import { roundToTwoDecimals } from 'utils/fomatting';

type Props = {
  totalScoreScaled?: number | null;
};

export const OverallScoreBar: React.FC<Props> = ({ totalScoreScaled }) => {
  const hasScore = typeof totalScoreScaled === 'number';

  return (
    <Stack gap="12px">
      <Typography
        sx={{
          fontSize: '16px',
          lineHeight: '26px',
          fontWeight: 400
        }}
      >
        {hasScore
          ? `Score ${roundToTwoDecimals(totalScoreScaled * 100)}%`
          : 'Score not available'}
      </Typography>
      <LinearProgress
        variant={hasScore ? 'determinate' : 'indeterminate'}
        value={hasScore ? totalScoreScaled * 100 : undefined}
      />
    </Stack>
  );
};
